import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RadioState } from '@app/core/states/radio.state';
import { ResetEditingTracks } from '@app/library/states/editing-track.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select } from '@ngxs/store';
import { SchedulerCoreState } from '@radioking/scheduler-core';
import { MobileSidenavService } from '@radioking/shared/common-services';
import { DynamicEnabledPanel } from '@radioking/shared/pannel-manager';
import { Observable } from 'rxjs';
import { SchedulerAllPlaylistsRequest } from '../../../../../../scheduler-core/src/lib/states/scheduler-core.actions';

import { Program } from '../../../models/programs.model';
import { ProgramsState } from '../../../states/programs.state';
import { MobProgramAddPlaylistComponent } from '../mob-program-add-playlist/mob-program-add-playlist.component';

@Component({
  selector: 'rk-mob-program-details',
  templateUrl: './mob-program-details.component.html',
  styleUrls: ['./mob-program-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobProgramDetailsComponent implements DynamicEnabledPanel {
  @Select(ProgramsState.programDetails)
  program$: Observable<Program>;
  @Select(SchedulerCoreState.hasPlaylists)
  hasPlaylists$: Observable<boolean>;
  @Select(RadioState.currentRadioId)
  radioId$: Observable<number>;

  constructor(private readonly mobileService: MobileSidenavService) {
    this.radioId$.subscribe(this.getPlaylists);
  }

  hasToShowConfirmOnExit(): boolean {
    return false;
  }

  isDirty(): boolean {
    return false;
  }

  @Dispatch()
  hide() {
    return new ResetEditingTracks();
  }

  @Dispatch()
  getPlaylists(id: number) {
    return new SchedulerAllPlaylistsRequest(id);
  }

  addPlaylist() {
    this.mobileService.open(MobProgramAddPlaylistComponent, {
      style: { display: 'flex', 'flex-direction': 'column' },
      bgType: 'gray',
      bottomFullHeight: true,
    });
  }
}
